const INRmetagopayOptions = [
    {value: "ANDB", label: "Andhra Bank"},
    {value: "AXIS", label: "Axis Bank"},
    {value: "BRDA", label: "Bank of Baroda"},
    {value: "BOIN", label: "Bank of India"},
    {value: "MHRT", label: "Bank of Maharashtra"},
    {value: "CANBK", label: "Canara Bank"},
    {value: "CSYB", label: "Catholic Syrian Bank"},
    {value: "CBOI", label: "Central Bank of India"},
    {value: "CITI", label: "Citi Bank"},
    {value: "CORB", label: "Corporation Bank"},
    {value: "DENB", label: "Dena Bank"},
    {value: "DNLM", label: "Dhan laxmi Bank"},
    {value: "FEDB", label: "Federal Bank"},
    {value: "HDFC", label: "HDFC Bank"},
    {value: "ICICI", label: "ICIC Bank"},
    {value: "IDBI", label: "IDBI Bank"},
    {value: "INDNB", label: "Indian Bank"},
    {value: "INOB", label: "Indian Overseas Bank"},
    {value: "INDU", label: "Indus Ind Bank"},
    {value: "JAKB", label: "Jammu and Kashmir Bank"},
    {value: "KARBK", label: "Karnataka Bank"},
    {value: "KOTBK", label: "Kotak Mahindra Bank"},
    {value: "OBOC", label: "Oriental Bank of Commerce"},
    {value: "PASB", label: "Punjab and Sind Bank"},
    {value: "PNJB", label: "Punjab NationalBank"},
    {value: "SCTRD", label: "Standard Chartered Bank"},
    {value: "SBBJ", label: "State Bank of Bikaner and Jaipur"},
    {value: "SBOH", label: "State Bank of Hyderabad"},
    {value: "SBIN", label: "State Bank of India"},
    {value: "SBOT", label: "State Bank of Travancore"},
    {value: "SIBK", label: "SouthIndian Bank"},
    {value: "SYNB", label: "Syndicate Bank"},
    {value: "TAMB", label: "Tamilnadu Mercantile Bank"},
    {value: "UCOB", label: "UCO Bank"},
    {value: "UNBOI", label: "Union Bank of India"},
    {value: "VJYB", label: "Vijaya Bank"},
    {value: "YESB", label: "Yes Bank"},
];

export default INRmetagopayOptions;
